import React, { useEffect, useRef, useState } from "react";

import yoyoLogo from "../assets/YoyoLetters.png";
import yoyovideoMobile from "../assets/video_website_desktop.mp4";
import yoyovideoDesktop from "../assets/video_website_desktop.mp4";
import iconweb from "../assets/Icon_rabbit.svg";
import cnplogo from "../assets/YOYObyCNP.svg";
import { useNavigate } from "react-router";

import "./Home.css";
function Home() {
  const navigate = useNavigate();
  const videoRef = useRef(null);

  // Detectar si es móvil
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 720);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const playVideo = async () => {
      if (videoRef.current) {
        try {
          videoRef.current.muted = true;
          await videoRef.current.play();
        } catch (error) {
          console.log("Autoplay prevented:", error);
          // Try to play on user interaction
          const playOnInteraction = () => {
            videoRef.current?.play();
            document.removeEventListener("touchstart", playOnInteraction);
            document.removeEventListener("click", playOnInteraction);
          };
          document.addEventListener("touchstart", playOnInteraction);
          document.addEventListener("click", playOnInteraction);
        }
      }
    };
    playVideo();
  }, []);
  return (
    <div className="App">
      <div className="videoOpacity" ></div>
      <div className="videoContainer">
        <video
          ref={videoRef}
          id="videoID"
          muted
          playsInline
          autoPlay
          loop
          webkit-playsinline="true"
          className="videoBody"
        >
          <source
            src={isMobile ? yoyovideoMobile : yoyovideoDesktop}
            type={isMobile ? "video/webm" : "video/mp4"}
          />
        </video>
      </div>

      <div
        className="bodyContainer"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          overflow: "overlay",
          paddingTop: "7vh",
          paddingBottom: "3vh",
        }}
      >
        <div style={{ overflow: "visible" }}>
          <div className="mainContainer">
            <img src={yoyoLogo} className="home-yoyologo" alt="YoYo Logo" />
          </div>
        </div>
        <div className="home-title-text-container2">
          <img src={iconweb} className="home-icon" alt="YoYo Logo" ></img>
          <p className="home-title-hero1">You've seen the Rabbit</p>
          <p className="home-title-hero2">Enter The Hidden Loop</p>
        </div>
        <div className="home-title-text-container">
          
                  <p className="home-title">
          Follow it into Mexico City’s hidden scene of experiences, nightlife
          and rewards.
        </p>
        </div>

        <div className="membership-container">
          <button
            onClick={() => navigate("/presignup")}
            className="yoyo-pill--white"
          >
            F&F MEMBERSHIP SIGN UP
          </button>
        </div>
        <div className="footerContainer" style={{ overflow: "visible" }}></div>

        <div className="home-footer-container">
          <div className="textFooterContainer" style={{ paddingTop: "20px" }}>
            {!isMobile && (<div className="footerLogos" style={{ scale: 0 }}>

              <img src={cnplogo} className="home-icon-cnp" alt="CNP Logo" />
            </div>)}
            <div
             className="textFooterRow"
            >
              <p className="textFotter">YOYO© All Rights Reserved 2026</p>
              <div
                onClick={() => navigate("/privacy")}
                className="textFotterLink"
              >
                Privacy Policy
              </div>
            </div>
            <div className="footerLogos">

              <img src={cnplogo} className="home-icon-cnp" alt="CNP Logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
